import React, { useState, useCallback } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { isBrowser } from 'utils/DeviceDetect';
import PropTypes from 'prop-types';

const CustomTooltip = ({ children, tooltip, placement, id, theme, ...props }) => {
    const [shouldUpdatePosition, setShouldUpdatePosition] = useState(false);

    const updatePosition = useCallback(() => {
        setShouldUpdatePosition(true);
    }, []);

    const getTheme = useCallback(() => {
        return theme ? `tooltip_${theme}` : '';
    }, [theme]);

    const getTooltip = useCallback(() => {
        if (React.isValidElement(tooltip)) {
            return React.cloneElement(tooltip, {
                overlayID: id,
                placement: placement,
                updatePosition: updatePosition,
            });
        }
        return tooltip;
    }, [tooltip, id, placement, updatePosition]);

    if (!isBrowser || !tooltip) {
        return children;
    }

    const tooltipElement = (
        <Tooltip id={id} className={getTheme()}>
            {getTooltip()}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            placement={placement || 'top'}
            overlay={tooltipElement}
            {...props}
        >
            {children}
        </OverlayTrigger>
    );
};

CustomTooltip.propTypes = {
    children: PropTypes.node,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    placement: PropTypes.string,
    id: PropTypes.string,
    theme: PropTypes.string
};

export default CustomTooltip;